// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3111":"80aa1e12","3453":"80aa1e12","3475":"80aa1e12","3549":"80aa1e12","3571":"d3b74a02","3998":"ad1b97f1","7465":"45d3f15d","9066":"80aa1e12"}[chunkId] + ".chunk.css";
};